import * as React from 'react';
import type { SVGProps } from 'react';
const SvgUnion = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 12"
    {...props}
  >
    <path
      fill="url(#Union_svg__a)"
      fillRule="evenodd"
      d="M7.518 0a.9.9 0 0 1 .9.9v1.477h2.305a1.8 1.8 0 0 1 1.799 1.798v6.026a1.8 1.8 0 0 1-1.8 1.799H4.29a1.8 1.8 0 0 1-1.8-1.799V4.174c.001-.993.806-1.797 1.8-1.797h2.329V.899a.9.9 0 0 1 .9-.899M5.482 4.927a1.35 1.35 0 1 0 0 2.698 1.35 1.35 0 0 0 0-2.698m4.047 0a1.35 1.35 0 1 0 0 2.698 1.35 1.35 0 0 0 0-2.698"
      clipRule="evenodd"
    />
    <path
      fill="url(#Union_svg__b)"
      d="M1.772 8.832H.9a.9.9 0 0 1-.899-.9V5.568a.9.9 0 0 1 .9-.9h.872z"
    />
    <path
      fill="url(#Union_svg__c)"
      d="M14.113 4.667a.9.9 0 0 1 .9.9v2.366a.9.9 0 0 1-.9.899h-.873V4.667z"
    />
    <defs>
      <linearGradient
        id="Union_svg__a"
        x1={12.197}
        x2={-6.564}
        y1={8.813}
        y2={8.324}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#256CF7" />
        <stop offset={1} stopColor="#C8D9FC" />
      </linearGradient>
      <linearGradient
        id="Union_svg__b"
        x1={12.197}
        x2={-6.564}
        y1={8.813}
        y2={8.324}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#256CF7" />
        <stop offset={1} stopColor="#C8D9FC" />
      </linearGradient>
      <linearGradient
        id="Union_svg__c"
        x1={12.197}
        x2={-6.564}
        y1={8.813}
        y2={8.324}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#256CF7" />
        <stop offset={1} stopColor="#C8D9FC" />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgUnion;
